import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/Generic/PageContent';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContent title={t('notFound.title')}>
      <Typography variant="subtitle1">{t('notFound.subtitle')}</Typography>
    </PageContent>
  );
};
export default NotFound;
